import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App.js';
import { preloadCatalogs } from './lib/i18n-catalogs.js';
import { localeFromPathname } from './lib/locale-routing.js';
import { DEFAULT_PLATFORM_BRAND } from './lib/default-brand.js';
import './styles/globals.css';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root not found');

/**
 * Load this visitor's language BEFORE mounting React.
 *
 * The four locale catalogues total 1.25 MB and used to sit in the entry chunk,
 * so every visitor downloaded every language. They are now separate chunks and
 * only two are fetched: the one the URL asks for, and English as the fallback.
 *
 * Waiting here is free. The app uses `createRoot`, not `hydrateRoot`, so the
 * PRE-RENDERED HTML stays on screen untouched until React replaces it — the
 * visitor is already looking at the finished page while this resolves, and
 * there is no hydration to mismatch and no flash of the wrong language.
 */
const locale = localeFromPathname(
  window.location.pathname,
  DEFAULT_PLATFORM_BRAND.supportedLocales,
  DEFAULT_PLATFORM_BRAND.defaultLocale,
);

void preloadCatalogs(locale === 'en' ? ['en'] : ['en', locale]).then(() => {
  createRoot(rootEl).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
